

export class UsuarioEntity {
  id?:number;
  username:string;
  nombres?:string;
  apellidos?:string;
  contrasena?:string;
  rol?:RolEntity;
  regional?:string;
  tiendas?:any[] = [];
  activo?:boolean;
  nombreCompleto?:string = ""
}

export class RolEntity {
  id?:number;
  nombre:string;
  permisos:number[] = [];
}

export class PermisoEntity {
  id?:number;
  nombre?:string;
}
